import React from 'react';
import PropTypes from 'prop-types';
import {
  CFormSwitch,
  CFormSelect,
  CCard,
  CCardBody,
  CBadge,
  CRow,
  CCol,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilChartLine, cilCheckCircle } from '@coreui/icons';

const AnalyticalPrediction = ({ config, setConfig }) => {
  // Храним выбранное окно авто-расчета внутри JSON-поля prediction_targets._history_days (по умолчанию 7 дней)
  const historyDays = config.prediction_targets?._history_days || 7;

  const handleHistoryDaysChange = (days) => {
    setConfig((prev) => ({
      ...prev,
      prediction_targets: {
        ...(prev.prediction_targets || {}),
        _history_days: Number(days),
      },
    }));
  };

  return (
    <CCard className="shadow-sm border-0 bg-white">
      <CCardBody className="p-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 border-bottom pb-3">
          <div>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <CFormSwitch
                size="xl"
                id="enable_pro_prediction"
                label="Включить режим PRO-Отчета (Авто-норма по прошлым дням, тренды ↑↓ и рейтинг)"
                checked={Boolean(config.enable_prediction)}
                onChange={(e) =>
                  setConfig({ ...config, enable_prediction: e.target.checked })
                }
                className="fw-bold text-dark fs-5"
              />
              <CBadge
                color={config.enable_prediction ? 'primary' : 'secondary'}
                shape="rounded-pill"
              >
                {config.enable_prediction
                  ? 'PRO РЕЖИМ АКТИВЕН'
                  : 'СТАНДАРТНЫЙ ОТЧЕТ'}
              </CBadge>
            </div>
            <div className="text-muted small mt-2 ms-5">
              • <b>Стандартный режим (выкл):</b> базовый отчет по выработке,
              простоям и потере связи.
              <br />• <b>PRO-режим (вкл):</b> система <b>сама</b> рассчитывает
              индивидуальную норму для каждой единицы техники на основе её
              работы за прошлые дни, сравнивает с текущим результатом,
              подсвечивает просадки (📈/📉), формирует рейтинг лидеров и
              добавляет отдельный лист <b>«PRO Аналитика и Тренды»</b> в Excel.
            </div>
          </div>
        </div>

        <div
          className={`transition-opacity ${
            !config.enable_prediction ? 'opacity-50 pe-none' : ''
          }`}
        >
          <CRow className="align-items-center bg-light p-3 rounded border g-3 mx-0">
            <CCol xs={12} md={7}>
              <div className="d-flex align-items-start gap-2">
                <CIcon
                  icon={cilChartLine}
                  size="xl"
                  className="text-primary mt-1 flex-shrink-0"
                />
                <div>
                  <div className="fw-bold text-dark">
                    База для автоматического расчета нормы (эталона)
                  </div>
                  <div className="text-muted small mt-1">
                    Перед отправкой отчета сервер автоматически проанализирует
                    работу каждой машины за выбранное число предыдущих дней (дни
                    полного простоя исключаются) и вычислит справедливую плановую
                    норму без ручного ввода.
                  </div>
                </div>
              </div>
            </CCol>

            <CCol xs={12} md={5}>
              <label className="small fw-bold text-muted mb-1 d-block">
                Период истории для расчета эталона:
              </label>
              <CFormSelect
                size="sm"
                className="fw-bold border-primary"
                value={historyDays}
                onChange={(e) => handleHistoryDaysChange(e.target.value)}
              >
                <option value={3}>За последние 3 дня</option>
                <option value={7}>За последнюю неделю (7 дней — Рекомендуется)</option>
                <option value={14}>За последние 2 недели (14 дней)</option>
                <option value={30}>За последний месяц (30 дней)</option>
              </CFormSelect>
            </CCol>
          </CRow>

          <div className="mt-3 d-flex align-items-center text-success small fw-semibold px-2">
            <CIcon icon={cilCheckCircle} className="me-2 flex-shrink-0" />
            <span>
              Ручной ввод параметров больше не требуется — нормативы объема,
              количества циклов и OEE пересчитываются автоматически при каждой
              отправке отчета.
            </span>
          </div>
        </div>
      </CCardBody>
    </CCard>
  );
};

AnalyticalPrediction.propTypes = {
  config: PropTypes.object.isRequired,
  setConfig: PropTypes.func.isRequired,
};

export default AnalyticalPrediction;